module.exports = __webpack_public_path__ + "static/media/203-303.6cd41850.png";